import moment               from 'moment';
import formattedDate        from './formattedDate';

const formattedAge = (dob, dod) => {
  const age = dod ? moment(dod).diff(dob, 'years', false) : moment().diff(dob, 'years', false);
  return formattedDate(dob, 'date') + ' (age ' + age + ')';
};

export default formattedAge;
